import { useMutation } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { toast } from 'sonner';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import type { PushAudienceInput } from '../model/types';

export const dashboardHandoffAPI = async (audience: PushAudienceInput) => {
  const response = await baseAPI.post<{ redirect: string }>(
    'mobile-inventor-push/dashboard-handoff',
    { audience },
  );
  return response.data;
};

export const useDashboardHandoff = () =>
  useMutation({
    mutationFn: dashboardHandoffAPI,
    onSuccess: () => {
      // Prefix only — history queries include filter params and would miss
      // MOBILE_INVENTOR_PUSH_LOGS() which keys as [..., 'logs', {}].
      void queryClient.invalidateQueries({
        queryKey: [KEYS.MOBILE_INVENTOR_PUSH, 'logs'],
      });
    },
    onError: (error: AxiosError<{ message?: string }>) => {
      toast.error(error.response?.data?.message ?? 'Dashboard handoff failed');
    },
  });
